import { Button } from "@/components/ui/button";
import { driverJs } from "@/lib/driver";
import { cn } from "@/lib/utils";
import { useLocation } from "@tanstack/react-router";

export default function AppTour() {
  const location = useLocation();
  const pathname = location.pathname;

  return (
    <Button
      className={cn({
        hidden: pathname !== "/dashboard",
      })}
      onClick={() => driverJs.drive()}
    >
      App Tour
    </Button>
  );
}
